import { Box, Checkbox, Grid, Menu, MenuItem, Tab, Tabs } from '@mui/material';
import SectionHeader from '../../components/SectionHeader';
import SearchToolbar from '../../components/SearchToolbar/SearchToolbar';
import { RGRLFilters } from './RGRL/components/RGRLFilters';
import useFileGenerationRGRL from './RGRL/hooks/useFileGenerationRGRL';
import EmptyTableSection from '../../components/DataTable/EmptyTableSection';
import DataTable from '../../components/DataTable/DataTable';
import { TEST_IDS } from './consts/testIds';
import { columnTitles } from './RGRL/consts/table';
import { renderStateChipSRT } from './RGRL/components/StateChipSRT';
import { useState } from 'react';
import { getDate } from '../../utils/common';
import { SRT_STATES } from './consts/states';
import BackdropComponent from '../../components/Backdrop/BackdropComponent';
import useTranslate, { TranslateFunction } from '../../hooks/useTranslate';
import { UploadErrorInfoAlert } from './RGRL/components/UploadErrorInfoAlert';
import { useNavigate } from 'react-router-dom';
import { enqueueSnackbar } from 'notistack';
import { TabPanel } from '../../components/TabPanel';
import { VisitsFilters } from './Visits/components/VIsitsFilters';
import useFileGenerationVisits from './Visits/hooks/useFileGenerationVisits';
import { VisitsTable } from './Visits/components/VisitsTable';
import { useTranslation } from 'react-i18next';
import { ActionsMenu } from '../../components/ActionsMenu/ActionsMenu';
import { setCurrentFileGenerationTab } from '../../redux/slices/srtPresentationsSlice';
import { useAppDispatch, useAppSelector } from '../../hooks/reduxHooks';
import DrawerManager, { DRAWER_ACTION_VALUES } from './drawers';
import { useRoles } from '../../hooks/useRoles';
import { useOrganizationFilter } from '../../contexts/OrganizationFilterContext';

export const getPresentationTypeName = (typeName: string, translate: TranslateFunction): string => {

    if (typeName === 'RGRL') {
        return translate('presentationTypeNames.rgrl');
    }

    if (typeName === 'RAR') {
        return translate('presentationTypeNames.rar');
    }

    return '-';
};


export enum TAB_INDEX {
    RGRL = 0,
    VISITS = 1
}

export type HandleTabChange = (event: React.SyntheticEvent, newValue: TAB_INDEX) => void;

const RGRLIndex = () => {
    const { t } = useTranslation('filesGenerationSRT');
    const { translate } = useTranslate(t);
    const [open, setOpen] = useState('');
    const currentTab = useAppSelector((state) => state.srtPresentations.currentTab);
    

    const handleCloseDrawer = () => {
        setOpen('');
    }
    const dispatch = useAppDispatch();
    
    const {
        filters,
        tableMenu,
        selectedItemFromAction,
        selected,
        selectedPresentations,
        presentations,
        isFetchingPresentations,
        presentationUploadErrors,
        contractsOptions,
        isFetchingContractsOptions,
        establishmentsOptions,
        isFetchingEstablishmentsOptions,
        isLoadingRgrl,
        isDownloadingPDF,
        isGeneretingFiles,
        startDate,
        endDate,
        isDownloading,
        setStartDate,
        setEndDate,
        handleDateChange,
        handleItemCheck,
        handleClickAction,
        handleRowClick,
        generateAndDownloadFiles,
        handleDownloadPresentation
    } = useFileGenerationRGRL(handleCloseDrawer);

    const navigate = useNavigate();
    const { isPerfilBackOffice } = useRoles();
    const { selectedOrganization } = useOrganizationFilter();

    const {
        filters: baseFilters,
        extraFilters,
        handleSubmitSearch,
        handleChangeExtraFilters,
        setFilters,
        clearFilters
    } = filters;

    const {
        visitsFilters,
        visitas,
        isFechingVisits,
        isFetchingVisitTypes,
        visitTypesOptions,
        visitsTableMenu,
        selectedVisits,
        visitsTableMenuItems,
        selectedItemFromAction: selectedVisitItemFromAction,
        selected: selectedVisitElement,
        isDownloadingVisitActa,
        isGeneratingVisitsFiles,
        handleRowClick: handleVisitRowClick,
        handleClickAction: handleVisitClickAction,
        handleItemCheck: handleVisitItemCheck,
        generateAndDownloadFiles: generateAndDownloadVisitsFiles,
    } = useFileGenerationVisits(handleCloseDrawer);

    const {
        handleChangeExtraFilters: handleChangeVisitsExtraFilters,
        setFilters: setVisitsFilters,
        extraFilters: visitsExtraFilters,
        handleSubmitSearch: handleSubmitVisitsSearch,
        filters: visitsBaseFilters,
        clearFilters: visitsClearFilters
    } = visitsFilters;

    const { menuOpen, anchorEl, closeMenu } = tableMenu;

    const {
        menuOpen: visitsTableMenuOpen,
        anchorEl: visitsAnchorEl,
        closeMenu: visitsCloseMenu
    } = visitsTableMenu;

    const handleTabChange = (_event: React.SyntheticEvent, newValue: TAB_INDEX) => {
        dispatch(setCurrentFileGenerationTab(newValue));
    };

    return (
        <>
            <Grid container>
                <Grid item xs={12}>
                    <SectionHeader>
                        <SectionHeader.Title>{translate('header.title')}</SectionHeader.Title>
                        <Grid display="flex" direction={'row'}>
                            <TabPanel value={currentTab} index={TAB_INDEX.RGRL}>
                                <SectionHeader.IconHeader
                                    variant="outlined"
                                    text={translate('header.uploadSRTReply')}
                                    showIcon={false}
                                    testID={TEST_IDS.header.uploadSRTReply}
                                    onClick={() =>
                                        setOpen(DRAWER_ACTION_VALUES.UPLOAD_RESPONSE_SRT)
                                    }
                                />
                            </TabPanel>
                            <SectionHeader.IconHeader
                                text={translate('header.generateFiles')}
                                showIcon={false}
                                testID={TEST_IDS.header.generateFiles}
                                onClick={() => {
                                    if (
                                        isPerfilBackOffice &&
                                        (!selectedOrganization || !selectedOrganization?.id)
                                    ) {
                                        enqueueSnackbar(
                                            translate('drawers.generateFilesSRT.enqueues.warning.noOrganizationSelected'),
                                            {
                                                variant: 'warning'
                                            }
                                        );
                                        return;
                                    }
                                    if (
                                        selectedPresentations?.length <= 0 &&
                                        currentTab === TAB_INDEX.RGRL
                                    ) {
                                        enqueueSnackbar(
                                            translate(
                                                'drawers.generateFilesSRT.enqueues.warning.noPresentationSelected'
                                            ),
                                            {
                                                variant: 'warning'
                                            }
                                        );
                                        return;
                                    }
                                    if (
                                        selectedVisits?.length <= 0 &&
                                        currentTab === TAB_INDEX.VISITS
                                    ) {
                                        enqueueSnackbar(
                                            translate(
                                                'drawers.generateFilesSRT.enqueues.warning.noVisitsSelected'
                                            ),
                                            {
                                                variant: 'warning'
                                            }
                                        );
                                        return;
                                    }
                                    setOpen(DRAWER_ACTION_VALUES.GENERATE_FILES_SRT);
                                }}
                            />
                        </Grid>
                    </SectionHeader>
                    <TabPanel value={currentTab} index={TAB_INDEX.RGRL}>
                        <UploadErrorInfoAlert
                            testID={TEST_IDS.errorsInfo}
                            presentationUploadErrors={presentationUploadErrors}
                            translate={translate}
                            establishmentsOptions={establishmentsOptions}
                            contractsOptions={contractsOptions}
                        />
                    </TabPanel>
                    <Grid display="flex" direction={'row'} bgcolor={'#fff'} pb={2} pl={3.5}>
                        <Tabs value={currentTab} onChange={handleTabChange}>
                            <Tab
                                sx={{ fontSize: '18px', fontFamily: 'Roboto, sans-serif' }}
                                label={translate('header.tabs.rgrl')}
                                value={TAB_INDEX.RGRL}
                            />
                            <Tab
                                sx={{ fontSize: '18px', fontFamily: 'Roboto, sans-serif' }}
                                label={translate('header.tabs.visits')}
                                value={TAB_INDEX.VISITS}
                            />
                        </Tabs>
                    </Grid>
                </Grid>

                <Grid item xs={12}>
                    <TabPanel value={currentTab} index={TAB_INDEX.RGRL}>
                        <SearchToolbar
                            inputSearchName=""
                            onChange={() => {}}
                            onClick={handleSubmitSearch}
                            showSearchInput={false}
                            clearFilters={() => {
                                setStartDate(null);
                                setEndDate(null);
                                clearFilters();
                            }}
                        >
                            <RGRLFilters
                                extraFilters={extraFilters}
                                setFilters={setFilters}
                                handleChangeExtraFilters={handleChangeExtraFilters}
                                contractsOptions={contractsOptions}
                                isFetchingContractsOptions={isFetchingContractsOptions}
                                establishmentsOptions={establishmentsOptions}
                                isFetchingEstablishmentsOptions={isFetchingEstablishmentsOptions}
                                startDate={startDate}
                                endDate={endDate}
                                handleDateChange={handleDateChange}
                            />
                        </SearchToolbar>
                    </TabPanel>
                    <TabPanel value={currentTab} index={TAB_INDEX.VISITS}>
                        <SearchToolbar
                            inputSearchName=""
                            onChange={() => {}}
                            onClick={handleSubmitVisitsSearch}
                            showSearchInput={false}
                            clearFilters={() => {
                                visitsClearFilters();
                            }}
                        >
                            <VisitsFilters
                                extraFilters={visitsExtraFilters}
                                setFilters={setVisitsFilters}
                                handleChangeExtraFilters={handleChangeVisitsExtraFilters}
                                contractsOptions={contractsOptions}
                                isFetchingContractsOptions={isFetchingContractsOptions}
                                establishmentsOptions={establishmentsOptions}
                                isFetchingEstablishmentsOptions={isFetchingEstablishmentsOptions}
                                handleDateChange={() => {}}
                                visitTypesOptions={visitTypesOptions}
                                isFetchingVisitTypes={isFetchingVisitTypes}
                            />
                        </SearchToolbar>
                    </TabPanel>
                </Grid>
                <Grid item xs={12}>
                    <TabPanel value={currentTab} index={TAB_INDEX.RGRL}>
                        {presentations?.data?.data?.length === 0 ? (
                            <EmptyTableSection title={translate('table.noData.title')} />
                        ) : (
                            <DataTable
                                testID={TEST_IDS.table.id}
                                columnTitles={columnTitles({ translate })}
                                columnWidths={[]}
                                onSelectRow={handleRowClick}
                                selected={selected}
                                selectedItemFromAction={selectedItemFromAction}
                                menuOpen={menuOpen}
                                items={presentations || []}
                                loading={isFetchingPresentations}
                                filters={baseFilters}
                                setFilters={setFilters}
                                isFetching={isFetchingPresentations}
                                headers={[
                                    {
                                        type: 'data',
                                        upperLabel: (item: any) => (
                                            <Checkbox
                                                checked={selectedPresentations.some(
                                                    (selectedPresentation: any) =>
                                                        selectedPresentation.id === item.id
                                                )}
                                                disabled={item?.estadoSRT === SRT_STATES.ERROR}
                                                onChange={() => handleItemCheck(item)}
                                            />
                                        )
                                    },
                                    {
                                        type: 'data',
                                        maxWidth: '200px',
                                        upperLabel: (item: any) =>
                                            getPresentationTypeName(item?.tipo?.nombre, translate)
                                    },
                                    {
                                        type: 'data',
                                        maxWidth: '250px',
                                        upperLabel: (item: any) =>
                                            `${item?.establecimiento?.organismo?.contrato?.cuit} - ${item?.establecimiento?.organismo?.contrato?.nombre}`
                                    },
                                    {
                                        type: 'data',
                                        maxWidth: '250px',
                                        upperLabel: (item: any) =>
                                            `${item?.establecimiento?.numero} - ${item?.establecimiento?.nombre}`
                                    },
                                    {
                                        type: 'data',
                                        maxWidth: '250px',
                                        upperLabel: (item: any) =>
                                            getDate(item?.fechaPresentacion) || '-'
                                    },
                                    {
                                        type: 'data',
                                        upperLabel: (item: any) =>
                                            renderStateChipSRT(item?.estadoSRT, translate)
                                    },
                                    {
                                        type: 'data',
                                        upperLabel: (item: any) =>
                                            item?.archivos[0]?.fechaGeneracion
                                                ? getDate(item.archivos[0].fechaGeneracion)
                                                : '-'
                                    },
                                    {
                                        type: 'action',
                                        onClick: handleClickAction
                                    }
                                ]}
                            />
                        )}
                    </TabPanel>
                    <TabPanel value={currentTab} index={TAB_INDEX.VISITS}>
                        <VisitsTable
                            items={visitas || []}
                            t={t}
                            handleItemCheck={handleVisitItemCheck}
                            selectedVisits={selectedVisits}
                            translate={translate}
                            handleRowClick={handleVisitRowClick}
                            selected={selectedVisitElement}
                            selectedItemFromAction={selectedVisitItemFromAction}
                            menuOpen={visitsTableMenuOpen}
                            filters={visitsBaseFilters}
                            setFilters={setVisitsFilters}
                            isFetching={isFechingVisits}
                            handleClickAction={handleVisitClickAction}
                        />
                    </TabPanel>
                </Grid>
                <TabPanel value={currentTab} index={TAB_INDEX.RGRL}>
                    <Menu id="basic-menu" anchorEl={anchorEl} open={menuOpen} onClose={closeMenu}>
                        <Box>
                            {selectedItemFromAction?.estadoSRT === SRT_STATES.ERROR && (
                                <MenuItem
                                    data-testid={TEST_IDS.table.actions.editPresentation}
                                    onClick={() => {
                                        const establihsmentData = establishmentsOptions.find(
                                            (establishmentOptions: any) =>
                                                selectedItemFromAction?.establecimiento?.id ===
                                                establishmentOptions?.id
                                        );
                                        localStorage.setItem(
                                            'selectedPresentationId',
                                            selectedItemFromAction?.id.toString()
                                        );
                                        navigate(
                                            `/backoffice/establecimiento/presentaciones/editar`,
                                            {
                                                state: {
                                                    selectedPresentationId:
                                                        selectedItemFromAction?.id,
                                                    selectedEstablishmentId:
                                                        selectedItemFromAction?.establecimiento?.id,
                                                    tipoId: selectedItemFromAction?.tipo?.id,
                                                    tipoTitulo:
                                                        selectedItemFromAction?.tipo?.nombre,
                                                    selectedSRTCode: establihsmentData?.numero
                                                }
                                            }
                                        );
                                    }}
                                >
                                    {translate('table.actions.editPresentation')}
                                </MenuItem>
                            )}
                            {selectedItemFromAction?.estadoSRT !== SRT_STATES.ERROR && (
                                <MenuItem
                                    data-testid={TEST_IDS.table.actions.seePresentation}
                                    onClick={() => {
                                        navigate(
                                            `/backoffice/establecimiento/presentaciones/visualizar`,
                                            {
                                                state: {
                                                    selectedPresentationId:
                                                        selectedItemFromAction?.id,
                                                    selectedEstablishmentId:
                                                        selectedItemFromAction?.establecimiento?.id,
                                                    tipoId: selectedItemFromAction?.tipo?.id,
                                                    tipoTitulo: selectedItemFromAction?.tipo?.nombre
                                                }
                                            }
                                        );
                                    }}
                                >
                                    {translate('table.actions.seePresentation')}
                                </MenuItem>
                            )}
                            <MenuItem
                                data-testid={TEST_IDS.table.actions.downloadPresentationPDF}
                                onClick={handleDownloadPresentation}
                            >
                                {translate('table.actions.downloadPDF')}
                            </MenuItem>
                        </Box>
                    </Menu>
                </TabPanel>
                <TabPanel value={currentTab} index={TAB_INDEX.VISITS}>
                    <ActionsMenu
                        menuItems={visitsTableMenuItems}
                        anchorEl={visitsAnchorEl}
                        menuOpen={visitsTableMenuOpen}
                        closeMenu={visitsCloseMenu}
                    />
                </TabPanel>
            </Grid>
            <DrawerManager
                open={open}
                setOpen={setOpen}
                translate={translate}
                handleCloseDrawer={handleCloseDrawer}
                generateAndDownloadFiles={
                    currentTab === TAB_INDEX.RGRL
                        ? generateAndDownloadFiles
                        : currentTab === TAB_INDEX.VISITS
                        ? generateAndDownloadVisitsFiles
                        : () => {}
                }
                currentTab={currentTab}
            />
            <BackdropComponent
                loading={
                    isLoadingRgrl ||
                    isDownloading ||
                    isDownloadingPDF ||
                    isDownloading ||
                    isDownloadingVisitActa ||
                    isGeneratingVisitsFiles
                }
                fetching={isGeneretingFiles}
            />
        </>
    );
};

export default RGRLIndex;
